import { render, staticRenderFns } from "./ImageUploaderModal.vue?vue&type=template&id=42dd4a49&scoped=true"
import script from "./ImageUploaderModal.vue?vue&type=script&lang=ts"
export * from "./ImageUploaderModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageUploaderModal.vue?vue&type=style&index=0&id=42dd4a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dd4a49",
  null
  
)

export default component.exports